/* eslint-disable max-len */
import React, { Component } from 'react';
import '../../Common/customStyles.scss';
import styles from './flexSetPage.scss';
import FragmentPlaceholder from '../../Common/fragment-placeholder/fragment-placeholder';
import { IFlexSetPageContext, IFlexSetPageState } from '../../components/flexSets/flexSetPage.d';
import StickyHeader from '../stickyHeader/stickyHeader';
import { GlobalSpinnerState } from '../globalState/globalState';
import classnames from 'classnames';
import * as helper from '../../Common/html-helper';
import { ScrollLock } from '../../../Helper/scrollLock';
import FspTileContextProvider from '../../components/globalState/fspTileContext';
import FspTileGrid from '../flexSets/fspTileGrid/fsp-tile-grid';
import Paging from '../paging/paging';
import { ArticleTilesAjaxCaller } from '../articleTileGrid/ArticleTilesAjaxCaller';
import { IUrlController, UrlController } from '../globalState/UrlController';
import { ViewType } from '../../Common/enums';
import TabNavigationHelper from '../../Common/tabNavigationHelper';
import ProgressBarAnimation from '../progressBarAnimation/progressBarAnimation';

export default class FlexSetPage extends Component<IFlexSetPageContext, IFlexSetPageState> {
    private categoryRef = React.createRef<HTMLDivElement>();
    private gridRef = React.createRef<HTMLDivElement>()
    private filterExist: boolean;
    private onlyHaveDeliveryTime: boolean;
    private historyTileId: string;
    private articleTilesAjaxCaller: ArticleTilesAjaxCaller;
    private spinner: GlobalSpinnerState;
    private urlController: IUrlController;
    private infinityScrollingIsLoading: boolean;
    constructor(props) {
        super(props);
        this.state = {
            waitingForResponse: false,
            scrollPosition: 0,
            isStickyHeaderVisible: false,
            mounted: false,
            infiniteScrollUpMode: helper.isUrlWithFlexSetPageQuery(this.props.url),
            infiniteScrollUpMinPageNo: this.props.page.pageNumber,
            isCategoryBottomReached: false,
            pageNo: this.props.page.pageNumber,
            pageEndOffset: this.props.page.pageEndOffset,
            sets: this.props.sets,
        };

        this.spinner = new GlobalSpinnerState();
        this.articleTilesAjaxCaller = new ArticleTilesAjaxCaller(this.spinner, this.props.magicLink);

        this.handleLoadArticles = this.handleLoadArticles.bind(this);
        this.stickyHeaderVisibleChange = this.stickyHeaderVisibleChange.bind(this);
        this.infiniteScroll = this.infiniteScroll.bind(this);
        this.urlController = new UrlController(this.props.seoSlug, ViewType.Category, this.props.magicLink);
        if (typeof document !== 'undefined') {
            if (this.historyTileId && this.historyTileId.length > 0) {
                // prevent default scroll restoration:
                window.history.scrollRestoration = 'manual';
                // for apple devices (iphone):
                ScrollLock.instance.lock();
            }

            document.addEventListener('DOMContentLoaded',
                () => {
                    if (window && window.location) {
                        if (this.historyTileId && this.historyTileId.length > 0) {
                            if (this.state.pageNo > 1) {
                                this.infiniteScroll();
                            } else {
                                setTimeout(() => {
                                    ScrollLock.instance.unlock();
                                    document.querySelector(this.historyTileId).scrollIntoView({ behavior: 'auto', block: 'center', inline: 'center' });
                                    this.historyTileId = '';
                                }, 300);
                            }
                        }
                    }
                });
        }
    }

    componentDidMount(): void {
        if (window && window.location) {
            if (window.location.hash.startsWith('#FS')) {
                this.historyTileId = window.location.hash;

                //remove hash
                history.replaceState(null, null, window.location.pathname + window.location.search);
            }
        }

        if (window && window.location && window.location.search.indexOf('page_set=') >= 0) {
            const params = new URL(window.location.href).searchParams;
            params.delete('page_set');
            let newUrl = window.location.pathname;
            if (params.size > 0) {
                newUrl += '?' + params.toString();
            }
            history.replaceState(null, null, newUrl);
        }
    }

    componentWillUnmount(): void {
        this.setState({
            mounted: false
        });
    }

    public stickyHeaderVisibleChange(visible: boolean) {
        if (visible !== this.state.isStickyHeaderVisible) {
            this.setState({ isStickyHeaderVisible: visible });
        }
    }

    private infiniteScroll() {
        if (
            this.state.infiniteScrollUpMode && // we have returned from somwhere to ATS
            this.state.infiniteScrollUpMinPageNo > 1 && // there are missing pages still
            !this.infinityScrollingIsLoading // we dont currently wait for an older load
        ) {
            const lastScrollHeight = window.document.body.scrollHeight;
            this.infinityScrollingIsLoading = true;
            this.articleTilesAjaxCaller.loadMoreFlexSets(
                this.state.infiniteScrollUpMinPageNo - 1,
                this.props.kiosk,
                false
            ).then((data) => {
                this.infinityScrollingIsLoading = false;
                this.setState(oldState => {
                    const mergedSets = Array.isArray(data.sets) ? data.sets.concat(oldState.sets) : oldState.sets;
                    return {
                        sets: [...mergedSets],
                        infiniteScrollUpMinPageNo: this.state.infiniteScrollUpMinPageNo - 1,
                    };
                });
            }).finally(() => {
                ScrollLock.instance.unlock();
                if (this.historyTileId && this.historyTileId.length > 0) {
                    document.querySelector(this.historyTileId).scrollIntoView(
                        { behavior: 'auto', block: 'center', inline: 'center' });
                    this.historyTileId = '';
                } else {
                    // we want to keep the scroll position
                    setTimeout(() => {
                        const heightDifference = window.document.body.scrollHeight - lastScrollHeight;
                        window.scrollBy({ top: heightDifference });
                    }, 100);
                }
            })
                .catch(() => {
                    ScrollLock.instance.unlock();
                    this.infinityScrollingIsLoading = false;
                });
        }
    }

    public render() {
        const applyAdditionalPadding = this.filterExist ? this.onlyHaveDeliveryTime
            : true;

        const isNewsLetterVisible = !(this.props.kiosk || this.props.isMobile)
            && this.state.isStickyHeaderVisible
            && this.props.sets.length > 4;

        return (
            <FspTileContextProvider l10n={this.props.l10n} cdnUrl={this.props.cdnUrl}>
                <div className={styles.categorypage} ref={this.categoryRef} data-testid='categorypage'>
                    <div className={styles.header}>
                        <div className={classnames(styles.breadcrumb_fragment_container, styles.is_breadcrumb_only, styles.is_fsp,
                            { [styles.is_mobile]: this.props.isMobile },
                            { [styles.additional_padding]: applyAdditionalPadding })}>
                            {!this.props.category.hideBreadcrumbAndFilterBar &&
                                // eslint-disable-next-line max-len
                                <React.Fragment>
                                    <FragmentPlaceholder
                                        src={'ESPP.Breadcrumb/breadcrumb?pageType=Category&seoSlug=' +
                                            this.props.category.seoSlug + '&containerId=ats_cp_main_breadCrumb&showH1Tag=' +
                                            this.props.showH1Tag + '&addNavKeyPathMeta=true'}
                                        ignoreErrors={true}
                                        timeout={2}
                                    />
                                    <div className={styles.header_set_count}>
                                        {this.props.page.totalArticleCount} {helper.decodeHTML(this.props.l10n.sets)}
                                    </div>
                                </React.Fragment>
                            }
                        </div>
                        {
                            <div id='ats_scope-fas-bar' className='fas_scope-fas'>
                                {this.props.page.totalResultCount > 0 &&
                                    !this.props.category.hideBreadcrumbAndFilterBar &&
                                    <ProgressBarAnimation
                                        scrollPosition={this.state.scrollPosition}
                                        pageEndOffset={this.state.pageEndOffset}
                                        salesDesignationViews={this.state.sets}
                                        totalResultCount={this.props.page.totalResultCount}
                                        infiniteScroll={this.infiniteScroll}
                                    />
                                }
                            </div>
                        }
                    </div>
                    {!this.props.category.hideStickyHeader &&
                        <StickyHeader isBreadcrumbOnly={true} isEsApp={this.props.isEsApp}
                            isFsp
                            isGlobal={this.props.isGlobal} gridRef={this.gridRef}
                            visibleCallBack={this.stickyHeaderVisibleChange}
                            renderNLP={!this.props.isMobile}
                            nlpIsVisibleByParentRules={isNewsLetterVisible}>
                            {
                                <div className={classnames(
                                    styles.breadcrumb_fragment_container,
                                    styles.sticky_header_fsp_container,
                                    { [styles.is_mobile]: this.props.isMobile },
                                    { ['fas_is_global']: this.props.isGlobal === true }
                                )}>
                                    <FragmentPlaceholder
                                        src={'ESPP.Breadcrumb/breadcrumb?pageType=Category&seoSlug=' +
                                            this.props.category.seoSlug + '&containerId=ats_sh_cp_breadCrumb'}
                                        ignoreErrors={true}
                                        timeout={2}
                                    />
                                    <div className={styles.sticky_article_count}>
                                        {this.props.page.totalArticleCount} {helper.decodeHTML(this.props.l10n.sets)}
                                    </div>
                                </div>
                            }
                            {!this.props.category.hideBreadcrumbAndFilterBar &&
                                <ProgressBarAnimation
                                    scrollPosition={this.state.scrollPosition}
                                    pageEndOffset={this.state.pageEndOffset}
                                    salesDesignationViews={this.state.sets}
                                    totalResultCount={this.props.page.totalResultCount}
                                    infiniteScroll={this.infiniteScroll}
                                />
                            }
                        </StickyHeader>
                    }
                    <FspTileGrid
                        flexSets={this.state.sets}
                        currencyInformation={this.props.currencyInformation}
                        category={this.props.category}
                        l10n={this.props.l10n}
                        kiosk={this.props.kiosk}
                        isMobile={this.props.isMobile}
                        isGlobal={this.props.isGlobal}
                        gridRef={this.gridRef}
                        addItemOriginToPdpLink={false}
                        portal={this.props.portal}
                        culture={this.props.culture}
                        urlController={this.urlController}
                    />
                    {this.props.page.totalArticleCount > 0 &&
                        <Paging
                            viewedArticleNumber={this.state.pageEndOffset}
                            totalArticleCount={this.props.page.totalArticleCount}
                            waitingForResponse={this.state.waitingForResponse}
                            onLoadMore={this.handleLoadArticles} l10n={this.props.l10n}
                            totalPagesNumber={this.props.page.totalPageCount}
                            currentPageNumber={this.state.pageNo}
                            url={this.props.url}
                            showHiddenLinks={true}
                            isFsp />
                    }
                </div>
            </FspTileContextProvider>
        );
    }

    private handleLoadArticles(focusFirstTileInNewPage?: boolean) {
        this.setState({ waitingForResponse: true });
        this.articleTilesAjaxCaller
            .loadMoreFlexSets(
                this.state.pageNo + 1,
                this.props.kiosk,
                true)
            .then((data) => {
                if (data) {
                    this.setState(oldState => {
                        const mergedSets = oldState.sets.concat(Array.isArray(data.sets) ? data.sets : []);
                        return {
                            pageNo: oldState.pageNo + 1,
                            pageEndOffset: data.pageEndOffset,
                            sets: mergedSets
                        };
                    }, () => {
                        const scrollPos = helper.calculateScrollDistance(
                            this.state.pageEndOffset,
                            this.state.sets);
                        this.setState({ scrollPosition: scrollPos });
                        this.props.page.pageNumber = this.state.pageNo;
                        TabNavigationHelper.instance.focusFirstSetInNewPage(
                            this.gridRef, focusFirstTileInNewPage, data.sets);
                    });
                }
                this.setState({ waitingForResponse: false })
            });
    }
}
